import React, {ReactNode} from "react";
import {SxProps} from "@mui/system";
import {Grid, Theme, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";

export function FormSection(props: {
  title: string,
  showBorder?: boolean,
  children?: ReactNode,
  sx?: SxProps<Theme>,
}) {
  const theme = useTheme();
  const sxSection: SxProps<Theme> = {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    },
    padding: theme.spacing(1),
  }
  const sxBorder: SxProps<Theme> = {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 1,
    borderColor: 'lightgrey',
  };
  let sx: SxProps<Theme> = sxSection;
  if (props.sx) {
    sx = {...sx, ...props.sx} as SxProps<Theme>
  }
  if (props.showBorder) {
    sx = {...sx, ...sxBorder} as SxProps<Theme>
  }

  return (
    <Grid container={true} sx={sx}>
      <Grid item={true} xs={12} sx={{
        marginBottom: theme.spacing(3),
        '& *': {
          fontSize: '1.5rem',
          fontWeight: 400,
        }
      }}>
        <Typography variant={"h3"}>{props.title}</Typography>
      </Grid>
      <Grid item={true} xs={12} sx={{
        [theme.breakpoints.down('sm')]: {
          paddingRight: theme.spacing(0),
        },
        paddingRight: theme.spacing(2),
      }}>
        {props.children}
      </Grid>
    </Grid>
  )
}
